export default {
  'Home': 'Home',
  'PODISMO':'RUNNING',
  'CICLISMO':'CYCLING',
  'CICLISMO su STRADA':'CYCLYNG',
  'ALTRISPORT':'MORE SPORTS',
  'TUTTI':'ALL',
  'ULTIMECLASSIFICHE':'LAST RESULTS',
  'PROSSIMIEVENTI':'NEXT EVENTS',
  'EVENTILIVE':'LIVE EVENTS',
  'CLASSIFICHE':'RESULTS',
  'EVENTI':'EVENTS',
  'CLASSIFICA':'Results',
  'VAI ALLE CLASSIFICHE':'Go to results',
  'VEDITUTTE':'See all',
  'DIRITTIRISERVATI': 'All Rights Reserved - VAT ',
  'Cronometraggio eventi sportivi' : 'Timing events',
  'EVENTI IN EVIDENZA' : 'IN EVIDENCE',
  'LE ULTIMISSIME DAI CAMPI DI GARA':'LATEST NEWS',
  'ACCEDI ad ICRONGO':'Login to ICRONGO',
  'Accedi':'Login',
  'Ricorda password':'Remember password',
  'Password dimenticata':'Forgot your password?',
  'Non sei registrato':'Not yet registered...?',
  'Registrati ora':'Register now',
  'TEMPO': 'TIME',
  'MEDIA': 'AVG',
  'SQUADRA': 'TEAM',
  'ATLETA': 'ATHLETE',
  'PETT':'BIB',
  'NAZ':'NAT',
  'CAT':'AG',
  'PCAT':'AG POS',
  'VEDI COMPLETA':'SEE ALL',
  'UOMINI':'MALE',
  'DONNE':'FEMALE',
  'SQUADRE':'TEAMS',
  'CLASSIFICATI':'OVERALL',
  'TOTALI':'OVERALL',
  'LOCALITA':'PLACE',
  'MASCHILE':'MALE',
  'CATEGORIA':'AGEGROUP',
  'FEMMINILE':'FEMALE',
  'TEMPO UFFICIALE':'OFFICIAL TIME',
  'ALTRI DATI STATISTICI':'MORE DATA',
  'GENERALE':'OVERALL',
  'Categoria':'Age group',
  'GEN':'OVRL',
  'SOC':'TEAM',
  'POS. ASSOLUTA':'OVERALL RESULT',
  'POS. CATEGORIA': 'AGEGROUP RESULT',
  'SERVIZI': 'SERVICES',
  'REGISTER': 'REGISTER',
  'PREVENTIVI': 'QUOTATIONS',
  'CONTATTI': 'CONTACTS',
  'IL TEAM': 'TEAM',
  'PRESIDENTI':'PRESIDENTS',
  'Gestione integrata eventi sportivi': 'Sport Events Management',
  'Vaiallevento' : 'Go to the event',
  'Vedilive' : 'Go live',
  'ISCRIZIONI CHIUSE':'REGISTRATION CLOSED',
  'Chiusura iscrizioni': 'Registration until ',
  'giorni':'days',
  'tra':' ',
  'DOMANI':'TOMORROW',
  'OGGI':'TODAY',
  'Scadenza':'Deadline',
  'VAIALLACLASSIFICA':'More results',
  'Vaiallasezioneeventi' : 'More events',
  'CHI SIAMO':'TEAM',
  'SCHEDE':'CARDS',
  'ELENCO':'LIST',
  'CARICA ALTRI EVENTI':'LOAD MORE EVENTS',
  'Ricerca':'SEARCH',
  'Annulla': 'CANCEL',
  'Cerca nome gara o localita':'Search event name or location',
  'Filtra per sport':'Filter by sport',
  'Filtra per anno':'Filter by year',

  'REGISTRAZIONE PROFILO':'REGISTRATION',
  'welcome':'Welcome to ICRONGO',
  'intro':'The registration to ICRON platform requires a personal email address.',
  'Dati anagrafici':'ACCOUNT DATA',
  'Nome' : 'Firstname',
  'Cognome' : 'Lastname',
  'Nazionalità':'Nationality',
  'Italiana' : 'Italian',
  'Straniera' : 'Foreign',
  'Maschio':'Male',
  'Femmina':'Female',
  'Codice fiscale': 'Fiscal code',
  'Ripeti': 'Repeat',
  'Telefono' : 'Phone number',
  'Dati di accesso' : 'Security',
  'per accedere': 'to login',
  'Chiudi':'Chiudi',
  'ALTRI DATI':'MORE DATA',
  'PREFERENZE':'PREFERENCES',
  'Dati utilizzati per emettere eventuali ricevute di iscrizione':'Used to compile receipts',
  'Dati consenso':'Consensus',
  'Data di nascita (gg/mm/aaaa)':'Birthdate (dd/mm/yyyy)',
  'Nazione':'Country',

  'INFO/ISCRIZIONI': 'INFO/REGISTRATION',
  'VERIFICA':'CHECK REGISTRATION',
  'ELENCO ISCRITTI':'PARTICIPANTS',

  'SCADENZE e LIMITAZIONI':'DEADLINE',
  'SCADENZE':'DEADLINE',
  'LIMITAZIONI':'maximum number of registrations',
  'CHIUSURA ISCRIZIONI':'REGISTRATION DEADLINE',
  'INFO E CONTATTI':'INFO AND CONTACTS',
  'SITO':'WEBSITE',
  'IMPOSTAZIONI':'SETTINGS',
  'GIORNIALLEVENTO':'DAYS TO THE EVENT',
  'LOCANDINA':'ANNOUNCEMENT',
  'ALLEGATI':'ATTACHMENTS',
  'CRONOMETRAGGIO':'TIMING BY',
  'ANNUNCI':'ADVERTISING',
  'QUOTE':'PRICING',
  'INFOCOMMISSIONE' : '* a commission will be applied to the list price in the case of online payment',
  'MAPPA':'MAP',

  'ISCRIZIONI CHIUSE':'REGISTRATION CLOSED',
  'Iscrivi da rubrica':'Subscribe from address book ',
  'SUPPORTO': 'SUPPORT',
  'Iscriviti':'Register',
  'GIAISCRITTO':'You\'re already registered. Go to the summary',
  'Numero massimo di iscrizioni accettate':'Max registrations allowed',
  'Numero posti disponibili':'Available tickets',
  'ZOOM':'Click to zoom',
  'fino a chiusura iscrizioni':'until deadline',

  'ISCRITTI':'REGISTERED',
  'FILTRO':'FILTER',
  'TUTTI':'ALL',
  'CHIUDI':'CLOSE',
  'RIEPILOGO ISCRIZIONI':'REGISTRATION SUMMARY',
  'ISCRIVI UN AMICO':'REGISTER A FRIEND',
  'Stato pagamento': 'Payment status',
  'Stato certificato':'Medical certificate status',
  'Allega':'Attach a document',
  'Vai al pagamento':'Go to the payment',
  'Caricamento evento':'Loading',

  'DIVISIONE SELEZIONATA':'SELECTED DIVISION',
  'Seleziona la gara':'Select the race',
  'Seleziona la tessera dal tuo profilo':'Select a card from your profile',
  'o seleziona LIBERO':' or select LIBERO',
  'Seleziona il certificato medico dal tuo profilo' : 'Select a medical certificate from your profile',
  'TESSERA SELEZIONATA':'SELECTED CARD',
  'Le Federazioni/Enti ammessi dalla manifestazione sono:' : 'Federations allowed to the event are:',
  'E\' possibile partecipare come LIBERO non tesserato': 'You can register without a federation card',
  'Non è prevista la partecipazione di atleti LIBERI o non tesserati':'Federation card is mandatory',
  'Attenzione, è necessario selezionare una gara per continuare':'To continue you must to select a race',
  'Attenzione, è necessario caricare un certificato medico valido per continuare':'To continue you must load a medical certificate',
  'TORNA all\'evento':'Back to the event',
  'CONFERMA':'CONFIRM',
  'ANNULLA':'CANCEL',
  'Informazioni aggiuntive':'MORE DATA',
  'CERTIFICATO SELEZIONATO':'SELECTED',
  'ATTENZIONE ! Nel tuo profilo non sono presenti tessere di Federazioni o Enti ammessi dalla manifestazione.':'In your profile there are no card allowing the participation to the event',
  'Vai nella funzionalità "Le mie tessere" per caricare una tessera valida': 'Go to "My cards" to load a valid card',
  'ATTENZIONE ! Nel tuo profilo non sono presenti certificati medici validi per questa manifestazione.':'In your profile there are not medical certificates allowed to partecipate to the event.',
  'Vai nella funzionalità "I miei certificati" per caricare un certificato valido':'Go to "My certificates" to load a valid medical certificate',
  'LE MIE TESSERE':'MY CARDS',
  'Ho letto ed accetto i termini e le condizioni del servizio':'I have read and accept the terms and conditions of the service',
  'Ho letto ed accetto l\'informativa sulla privacy':'I have read and accept the privacy policy',
  'Attenzione, alcune tessere sono caricate automaticamente dai nostri sistemi<br> In questa area puoi caricare la tua tessera da portare sempre con te':'Attention, some cards are automatically loaded by our systems. \nHere you can load your card.',
  'INFOCARD':'Attention, some cards are automatically loaded by our systems. You can upload your card. Click LOAD CARD BUTTON',
  'CARICA TESSERA':'LOAD CARD',
  'IPHONE':'Be aware, you cannot upload any document if you use an Apple iPhone (it\'s a security limitation). Please, use a PC or an android device. Otherwise send your document by email to info@tempogara.it ',
  'AGGIUNGI TESSERA':'ADD A CARD',
  'Per inserire una tessera su ICRONGO è obbligatorio caricarne la foto o il pdf.':'To add a card to your profile you have to upload a picture  or a pdf of the card.',
  'La nostra segreteria verificherà e validerà le tessere e le stesse saranno associabili in automatico ai moduli di iscrizione agli eventi.':'Our backoffice will validate cards so that you can use them to register to events',
  'Le tessere sono visionabili solo da te a dagli organizzatori delle manifestazioni a cui ti iscrivi':'Your cards are visible only by you and by the owner of the event',
  'Numero tessera':'Card number',
  'Anno di validità':'Validity',
  'Ente':'Federation',
  'Denominazione società':'Team name',
  'Codice società':'Team code',
  'Clicca qui per caricare la tua tessera':'Click here to upload your card picture',
  'Salva':'Save',
  'Confermi la cancellazione della tessera ':'Are you sure to delete your card ',
  '"Caricare tutti i dati richiesti, compreso la scansione della tessera"':'Plase, fill all required data',
  'I MIEI CERTIFICATI':'MY MEDICAL CERTIFICATES',
  'Per inserire un certificato su ICRONGO è obbligatorio caricarne la foto o il pdf.':'To add a medical certificate to your profile you have to upload a picture  or a pdf of the certificate.',
  'La nostra segreteria verificherà e validerà il certificato e lo stesso sarà associabile in automatico ai moduli di iscrizione agli eventi.':'Our backoffice will validate the certificates so that, when required, you can use them to register to events',
  'Il certificato è visionabile solo da te, dal tuo Presidente di società (se fai parte della sua rubrica atleti) a dagli organizzatori delle manifestazioni a cui ti iscrivi':'Your cards are visible only by you and by the owner of the event',
  'Attenzione, resterai tu unico resposabile della sua veridicità e validità':'Attention, you will remain solely responsible for its truthfulness and validity',
  'AGGIUNGI CERTIFICATO':'ADD A MEDICAL CERTIFICATE',
  'Data scadenza (gg/mm/aaaa)':'Deadline (dd/mm/yyyy)',
  'Ho capito':'I undestood',
  'Carica certificato':'Load medical certificate',
  'Attenzione, alcune date di scadenza sono caricate automaticamente dai nostri sistemi sulla base degli archivi a nostra disposizione':'Be aware, some data are automatically load from our archives',
  'In questa area puoi caricare il tuo certificato da portare sempre con te. Ti ricordiamo che in alcune manifestazioni è comunque necessario portare con se il certificato originale':'In this area you can upload your certificate to take with you. We remind you that in some events it is still necessary to bring the original certificate with you',
  'Clicca qui per caricare il certificato':'Click here to upload your medical certificate',
  'CERTIFICATO MEDICO':'MEDICAL CERTIFICATE',

  'Certificato scaduto':'Overdaten',
  'Certificato validato':'Validated',
  'In attesa di validazione': 'Waiting for validation',
  'Certificato NON valido': 'Not valid',
  'RIEPILOGO ORDINE':'ORDER SUMMARY',
  'Seleziona il listino e procedi':'Select the price and continue',
  'Procedi':'Continue',
  'Indietro':'Back',
  'CHIUDI':'CLOSE',
  'Operazione completata con successo.':'Successful operation',
  'Paga':'Pay',
  'con PAYPAL o Carte di Credito':'with Paypal or Credit Card',
  'con Apple Pay e Google Pay':'with Apple Pay or Google Pay',
  'con SOFORT':'with SOFORT banking transfer Platform',
  'con SEPADIRECT':'with Sepa banking transfer',
  'sepa mandate':'By signing this mandate form, you authorise (A) {0} and Stripe, our payment service provider, to send instructions to your bank to debit your account and (B) your bank to debit your account in accordance with the instructions from {0} and Stripe. As part of your rights, you are entitled to a refund from your bank under the terms and conditions of your agreement with your bank. A refund must be claimed within 8 weeks starting from the date on which your account was debited.',
  'con Bonifico Bancario':'with Banking transfer',
  'Selezionare la modalità di pagamento':'Select a payment choose',
  'Ai pagamenti PAYPAL, Apple Pay, Google Pay e Carte di Credito sarà applicata una commissione di':'A fee will be applied to the registration',
  'Attenzione, al costo dell\'iscrizione sarà applicata una commissione di gestione pratica': 'A fee will be applied to the registration',
  'nel caso di pagamento tramite canale Paypal, Apple Pay, Google Pay o Carte di Credito':'if the payment is done with Paypal, Apple Pay, Google Pay or Credit Card',
  'nel caso di pagamento tramite bonifico bancario':'if the payment is done with banking transfer',
  'Commissioni':'Fee',
  'solo per pagamento Paypal': 'only for payment with Paypal',
  'a persona':'per person',
  'Importo da pagare con bonifico':'Amount to pay with banking transfer',
  'solo per bonifici':'only for payment with banking transfer',
  'Sconto coupon':'Coupon discount',
  'Importo da listino':'Total amount',
  'Listino':'Price list',
  'Sconto':'Discount',
  'Prezzo':'Price',
  'Hai scelto di pagare tramite Bonifico bancario.':'You have chosen to pay by bank transfer.',
  'Per procedere è necessario effettuare il bonifico bancario  di':'To proceed you must make the bank transfer of',
  'sul seguente conto corrente':'on the following bank account',
  'inserendo come causale il codice':'inserting the code as reason',
  'seguito da cognome e nome degli atleti interessati all\'operazione':'followed by the surname and name of the athletes interested in the operation',
  'e caricare la ricevuta di pagamento cliccando sul bottone sottostante':'and upload the payment receipt by clicking on the button below',
  'Hai scelto di pagare tramite Paypal o Carte di credito':'You have chosen to pay by Paypal or Credit Cards',
  'Hai scelto di pagare tramite Google Pay o Apple Pay':'You have chosen to pay via Google Pay or Apple Pay',
  'Hai scelto di pagare tramite Bonifico con circuito SOFORT':'You have chosen to pay via SOFORT Circuit',
  'Hai scelto di pagare tramite bonifico Sepa':'You have chosen to pay via Sepa Direct',
  'Il prezzo totale da pagare è di':'The total price to pay is',
  'Clicca sul bottone Paypal per procedere con l\'operazione.':'Click on the Paypal button to proceed with the operation.',
  'Complimenti, il tuo profilo è ATTIVO !':'Congratulation, your profile has been activated !',
  'Accedi con la tua email e la tua password per entrare in ICRONGO':'Log in with your email and password',
  'Registrati':'Register',
  'MODULO DI ISCRIZIONE':'REGISTRATION FORM',

  'SELEZIONA IL FILTRO':'SELECT A FILTER',
  'LE MIE ISCRIZIONI':'MY ORDERS',
  'FUNZIONALITA\' del PROFILO': 'MY FUNCTIONALITIES',
  'DATI PROFILO':'PERSONAL DATA',
  'I MIEI RISULTATI':'MY RESULTS',
  'LE MIE ISCRIZIONI': 'MY REGISTRATIONS',
  'LE MIE TESSERE': 'MY CARDS',
  'DISCONNETTI':'LOGOUT',
  'I MIEI CHIP':'MY CHIP',
  'LE MIE FOTO':'MY PHOTOS',
  'I MIEI PAGAMENTI':'MY PAYMENTS',
  'I MIEI CERTIFICATI':'MY CERTIFICATES',
  'NOTIFICHE':'NOTIFICATIONS',
  'Aggiorna profilo':'UPDATE PROFILE',
  'INFOPROFILO':'Attention, some profile data cannot be modified, such as the surname, name, tax code, email and privacy consent. If you need to change some of these send a request for assistance to the address segreteria@tempogara.it. However, we remind you that it is possible to completely delete the profile and all the data connected to it by clicking on the "Delete profile" button in the "Consent data" section at the bottom of the page',
  'CANCELLA PROFILO':'DELETE PROFILE',
  'INFOPROFILO2':'As from GPDR you can request the deletion of the profile and all the personal data connected by clicking on the following button',
  'Acconsento alla comunicazione dei miei dati verso terzi per promozione/vendita prodotti e servizi anche individuati tramite il mio profilo':'I consent to the communication of my data to third parties for promotion / sale of products and services also identified through my profile',
  'Acconsento al trattamento per finalità di marketing e per la ricezione di Newsletter':'I consent to processing for marketing purposes and for receiving newsletters',
  'PRIVACY1':'By registering you accept the Terms and Conditions of the service and you declare that you have read the Privacy information',

  'Complimenti, il tuo profilo è registrato.':'Congratulations, your account has been successfully registered.',
  'Per entrare nel profilo clicca su ACCEDI in alto a destra':'To enter click on LOGIN button in the upper right corner',
  'PREF1':'The preferences will be used to improve the usability of the portal or to pre-fill the registration forms for the events',
  'Procedi con la registrazione':'Continue',

  'Attenzione, compilare tutti i campi obbligatori':'Attention, fill in all mandatory fields',
  'PROBLEMATICHE': 'For registration issues write to',

  'ISCRIZIONE_PAGATA' : 'The subscription cannot be deleted because already confirmed. Contact the support for more info',

  'GESTIONETEAM1':'TEAM MANAGEMENT',
  'GESTIONETEAM2':'Keep track of your athletes\' data: memberships, certified deadlines, contacts, registrations',
  'LEGGERE CON ATTENZIONE':'MORE INFO',

  'Benvenuti !': 'Welcome',
  'WELCOMEMESSAGE': 'The new ICRON integrated platform completely renewed.  Register and find out ....',
  'PROFILO PERSONALE':'PERSONAL PROFILE',
  'PROFILOMESSAGE': 'Your personal area where you can view your results, your photos, manage registrations and payments with a few clicks',
  'Gallerie disponibili': 'Galleries',

  'Nuova password':'New password',
  'Ripeti nuova password': 'Repeat new password',

  'Data di nascita (calcolata dal codice fiscale)':'Date of birth',
  'Città di nascita (calcolata dal codice fiscale)':'Place of birth',
  'Indirizzo':'Address',
  'Citta di residenza':'City',
  'C.a.p.': 'Zip code',
  'Selezionare la città residenza':'Select city',
  'Selezionare dalla lista':'Select from the list',

  'STORICO PAGAMENTI':'PAYMENTS HISTORY',
  'Dettaglio':'Detail',

  'Data caricamento':'Upload date',
  'Tipo':'Type',
  'Note':'Note',

  'Atleta/Evento':'Person/Event',
  'Codice sconto':'Coupon',
  'Sconto':'Discount',
  'Totale':'Total',
  'Clicca qui per collegarti al sito dell\'evento':'Click here to connect to the event website',
  'SITO WEB':'WEB SITE',

  'Pagamento online non disponibile':'Online payment not available',
  'atleti visualizzati':' records',

  'VERIFICA ISCRIZIONE':'CHECK REGISTRATION',
  'Inserisci il tuo cognome o il nome della società':'Insert your lastname or your team name',
  'Cognome...':'Lastname...',
  'Societa o codice...':'Team name...',
  'CERCA':'SEARCH',

  'select an item': "* select an item * "


}
